module.exports = __webpack_public_path__ + "static/media/girl-mekup-2.b4216efb.png";